var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('header', {
    staticClass: "mb-3 mb-lg-5 d-flex flex-column align-items-center"
  }, [_c('h1', {
    staticClass: "text-20 text-lg-32 fw-400"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('span', {
    staticClass: "d-none d-lg-block bg-platform mt-3",
    style: {
      width: '75px',
      height: '4px'
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }